import React, { useCallback, useMemo, useState } from 'react';
import type { OnTableChange } from 'ksnm-common-ui/lib/Table2/contexts/Table/TableContext.interface';
import type { CSSProperties } from 'react';

import { numberWithSpaces } from '../numberUtils';

const wrapperStyle = { display: 'flex', flexDirection: 'column', gap: '5px' };

const countStyle = {
  margin: '0',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.02em',
  fontFeatureSettings: "'pnum' on, 'lnum' on",
  color: '#1B2028',
};

export const useTableTitleWithCount = (title: string | JSX.Element): [JSX.Element, (v: OnTableChange) => void] => {
  const [count, setCount] = useState(0);

  const onChangeTable = useCallback((v: OnTableChange) => {
    setCount(v.totalPhysicsRows);
  }, []);

  const t = useMemo(
    () => (
      <div style={wrapperStyle as CSSProperties}>
        {title}
        {!!count && <p style={countStyle}>Всего записей: {numberWithSpaces(count)}</p>}
      </div>
    ),
    [count, title],
  );

  return useMemo(() => [t, onChangeTable], [onChangeTable, t]);
};
